<template>
  <v-main class="phenotype-view">
    <v-row>
      <v-col cols="12" v-if="$vuetify.display.mobile" class="crumb text-left mb-8 ml-1">
        <span @click="openMyAccount">{{ $t('user.my_account_btn') }}</span> / <span class="bold">{{ $t('page.phenotype_name') }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" md="12" class="pa-0">
        <v-tabs
          background-color="secondary300"
          class="tabs ml-0 mt-0"
          v-model="currentPhenotype"
          :centered="$vuetify.display.mobile ? true : false"
        >
          <v-tab class="button text-none" value="own" id="own" @click="current = 'own'">
            {{ $t('recipient.my_phenotype_tab_name') }}
          </v-tab>
          <v-tab class="button text-none" value="partner" id="partner" @click="current = 'partner'">
            {{phenotype.partner.gender ? (
              phenotype.partner.gender == "MALE" ? $t('recipient.partner_male_phenotype_tab_name') : $t('recipient.partner_female_phenotype_tab_name')
            ) : $t('recipient.partner_no_gender_phenotype_tab_name') }}
          </v-tab>
        </v-tabs>
        <recipient-phenotype-component ref="recipientPhenotypeComponent"/>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import RecipientPhenotypeComponent from "../components/RecipientPhenotypeComponent.vue"
import { useStore, mapState } from "vuex";

export default {
  components: {
    RecipientPhenotypeComponent
  },
  data() {
    return {
      selectedTab: null,
      store: useStore(),
      current: null
    }
  },
  computed: {
    ...mapState('phenotypeModule', ['currentPhenotype','phenotype'])
  },
  watch: {
    current(n) {
      this.selectedTab = n;
      this.setCurrentPhenotype(this.current);
    }
  },
  created() {
    this.check_current()
  },
  mounted() {
    this.check_current()
  },
  methods: {
    setCurrentPhenotype(mode) {
      this.store.dispatch('phenotypeModule/setCurrentPhenotype', mode);
      this.$refs.recipientPhenotypeComponent.validationOn = false;
      this.selectedTab = this.currentPhenotype;
    },
    openMyAccount() {
      this.$emit('openMyAccount', true);
    },
    check_current() {
      let haveOwn = Object.keys(this.phenotype.own).length > 0;
      let havePartner = Object.keys(this.phenotype.partner).length > 0;
      if(!havePartner && haveOwn) {
        this.current = 'partner';
      } else {
        this.currnet = 'own';
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.v-row {
  margin: 0px !important;
  padding: 0px !important;
}
.sidebar {
  margin-bottom: 32px;
  background: white;
}
.phenotype-view {
  background-color: rgb(252, 252, 255) !important;
}
  .header {
    @include nsb-font-header-bold;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    // width: 100%;
  }

  .tabs {
    margin-bottom: -1px !important;
    .v-tab {
      color: $nsb-color-4 !important;
      font-size: 16px;
      line-height: 24px;
      padding-left: 32px;
      padding-right: 32px;

      &:first-of-type {
        border-right: none !important;
      }
      &.v-tab--selected {
        background: white !important;
        color: $ds-primary !important;
        border-bottom: 1px solid white !important;

        :deep(.v-tab__slider) {
          display: none;
        }
      }

      border-top-left-radius: 4px !important;
      border-top-right-radius: 4px !important;
    }
  .button {
    @include nsb-font-button;
    font-size: 14px !important;
  }
}
.crumb {
  @include nsb-select-option;
  font-size: 12px;
  color: $ds-primary;
  .bold {
    @include nsb-select-chip;
    font-size: 12px;
    color: $ds-primary;
  }
}
@media (min-width: 960px) {
  .phenotype-view {
    margin-bottom: 32px;
  }
  .header {
    // width: 100%;
    text-align: left;
    padding-left: 300px;
    @include nsb-font-header-bold;
    font-size: 22px;
    line-height: 33px;
    height: unset;
    min-height: unset;
  }
}
</style>